import { AfterContentInit, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router, ActivatedRoute, RouterLinkActive, RouterLink } from '@angular/router';
import { TranslocoService, TranslocoModule } from '@ngneat/transloco';
import { combineLatest, Subscription } from 'rxjs';
import { FaqSection } from '../../models';
import { SEOService } from '../../services';
import { MatIcon } from '@angular/material/icon';
import { FaqContentComponent } from '../../shared/components/faq-content/faq-content.component';
import { MatButton } from '@angular/material/button';
import { TitleCasePipe } from '@angular/common';


@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  standalone: true,
  imports: [
    TranslocoModule,
    RouterLinkActive,
    RouterLink,
    MatIcon,
    FaqContentComponent,
    MatButton,
    TitleCasePipe,
  ],
})
export class FaqComponent implements OnInit, AfterContentInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private seoService = inject(SEOService);
  private translocoService = inject(TranslocoService);

  public tabs = [
    {
      value: 'seller',
      route: 'vendeur',
    },
    {
      value: 'buyer',
      route: 'acheteur',
    },
    {
      value: 'organizer',
      route: 'organisateur',
    },
  ];
  public currentFragment: string;
  public faqSection: FaqSection;
  public FaqSection = FaqSection;

  private routeSubscription: Subscription;
  private fragmentSubscription: Subscription;
  private helpTranslations;

  ngOnInit() {
    this.routeSubscription = combineLatest([
      this.translocoService.selectTranslateObject('help', {}, 'fr-FR'),
      this.route.params,
    ]).subscribe(([translation, params]) => {
      this.helpTranslations = translation;
      this.setSection(params?.faqSection);
    });
  }

  ngAfterContentInit() {
    this.fragmentSubscription = this.route.fragment.subscribe((f) => {
      this.currentFragment = this.route.snapshot.fragment;
    });
  }

  setSection(faqTranslated: string) {
    if (Object.values(FaqSection).includes(faqTranslated as FaqSection)) {
      this.faqSection = faqTranslated as FaqSection;
    } else {
      const faqSection = Object.entries(this.helpTranslations)
        .find( ([k, v]) => v === faqTranslated) as [FaqSection, unknown];
      this.faqSection = faqSection?.[0] as FaqSection;
    }
    if (!Object.values(FaqSection).includes(this.faqSection)) {
      this.router.navigate(['404']);
    }

    this.setTitle(this.faqSection);
    if (this.route.snapshot?.fragment) {
      this.currentFragment = this.route.snapshot.fragment;
    }
  }

  setTitle(faqSection: string) {
    this.seoService.updateTitle('FAQ ' + faqSection?.[0].toUpperCase() + faqSection?.slice(1).toLowerCase() + ' - Reelax Tickets');
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
    this.fragmentSubscription?.unsubscribe();
  }

}
